/* eslint-disable no-bitwise */
// Create table on load. Used as reference to calculate crc checksum
const crcTable = (() => {
  let c;
  const table = [];

  for (let n = 0; n < 256; n++) {
    c = n;
    for (let k = 0; k < 8; k++) {
      // eslint-disable-next-line no-bitwise
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
})();

export class ZipEntry {
  // filename/dir name
  name;

  // is directory
  dir;

  // date modified
  date;

  // file content
  data;

  // compressed size
  // (compression not currently supported)
  compressedSize = 0;

  // uncompressed size
  uncompressedSize = 0;

  // compression algorithm (no compression)
  compression = '\x00\x00';

  // crc32 checksum
  crc32 = 0;

  // file comment
  comment = '';

  constructor(name, data, isDir) {
    const forceTrailingSlash = path => (path.slice(-1) !== '/' ? `${path}/` : path);
    this.name = isDir ? forceTrailingSlash(name) : name;
    this.dir = isDir;
    this.date = new Date();
    this.data = data;
  }

  /**
   * Processes file data and calculates size and checksum
   * @returns {Uint8Array} data converted to Uin8Array
   */
  processData() {
    // eslint-disable-next-line compat/compat
    let data = new Uint8Array();

    if (typeof this.data === 'string' && this.data.length) {
      data = ZipEntry.encodeData(this.data);
      this.crc32 = ZipEntry.calcCrc32(0, data, data.length, 0);
      this.compressedSize = data.length;
      this.uncompressedSize = data.length;
    }

    return data;
  }

  /**
   * Encode data string
   * @param {string} str string to convert
   * @returns {Uint8Array} buffer
   */
  static encodeData(str) {
    // eslint-disable-next-line compat/compat
    const encoder = new TextEncoder();
    return encoder.encode(str);
  }

  /**
   * Compute the crc32 of a buffer
   * @param {number} crc the starting value of the crc.
   * @param {any} buf the buffer to use.
   * @param {number} len the length of the buffer.
   * @param {number} pos the starting position for the crc32 computation.
   * @returns {number} the computed crc32
   */
  static calcCrc32(crc, buf, len, pos) {
    const t = crcTable;
    const end = pos + len;

    crc ^= (-1);

    for (let i = pos; i < end; i++) {
      crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1));
  }
}
